"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NameStyled = exports.AvatarStyled = exports.CellMemberStyled = exports.CellMemberWrapperStyled = void 0;
const styled_components_1 = __importStar(require("styled-components"));
exports.CellMemberWrapperStyled = styled_components_1.default.div `
  display: flex;
`;
exports.CellMemberStyled = styled_components_1.default.div `
  display: flex;
  padding: 4px 10px 4px 2px;
  background-color: var(--fc11);
  border-radius: 16px;
  margin: 2px 8px 2px 0;
`;
exports.AvatarStyled = styled_components_1.default.div `
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-repeat: no-repeat;
  background-size: cover;
  user-select: none;
  border: 1px solid var(--shadowColor);
  background-position: center;
  background-color: rgb(255, 255, 255);
  ${props => {
    if (props.avatar) {
        return (0, styled_components_1.css) `
        background-image: url(${props.avatar})
      `;
    }
    return (0, styled_components_1.css) ``;
}}
  ${props => {
    if (props.bg) {
        return (0, styled_components_1.css) `
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: ${props.bg};
        color: #fff;
        font-size: 10px;
      `;
    }
    return (0, styled_components_1.css) ``;
}}
`;
exports.NameStyled = styled_components_1.default.span `
  line-height: 20px;
  padding-left: 2px;
  font-size: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
